export const PACKAGE_DATA_PICKER_SET_VALUE = 'PACKAGE_DATA_PICKER_SET_VALUE';
export const PACKAGE_DATA_PICKER_CLEAN_VALUE = 'PACKAGE_DATA_PICKER_CLEAN_VALUE';

export const PACKAGE_DATA_PICKER_SET_BOOKS = "PACKAGE_DATA_PICKER_SET_BOOKS"

export const PACKAGE_DATA_PICKER_TOGGLE_BOOK = 'PACKAGE_DATA_PICKER_TOGGLE_BOOK';
export const PACKAGE_DATA_PICKER_REMOVE_BOOK = 'PACKAGE_DATA_PICKER_REMOVE_BOOK';

export const PACKAGE_DATA_PICKER_TOGGLE_VIDEO = 'PACKAGE_DATA_PICKER_TOGGLE_VIDEO';
export const PACKAGE_DATA_PICKER_REMOVE_VIDEO = 'PACKAGE_DATA_PICKER_REMOVE_VIDEO';